export default function Contact() {
  return (
    <div className="container">
      <h1>Contact Us</h1>

      <p>
        Have a question or want to collaborate with us? We’d love to hear from
        you.
      </p>

      <div style={{ marginTop: "20px" }}>
        <p>
          <strong>Email:</strong> support@bloomoranaturals.com
        </p>
        <p>
          <strong>Phone:</strong> +91 9XXXXXXXXX
        </p>
        <p>
          <strong>Location:</strong> New Delhi, India
        </p>
      </div>

      <p style={{ marginTop: "30px" }}>
        Business hours: Monday to Saturday, 10:00 AM – 6:00 PM IST
      </p>
    </div>
  );
}
